import { useSyncExternalStore } from 'react'
import { beginLayoutSwap } from '@papan/core-ui/ui'

/**
 * The chat home drops to a single column below 950px — earlier than the
 * app-wide 768px phone swap (`useIsPhone` / `useIsDesktop`), because the
 * conversations rail, the hero and the right column need more room than the
 * other desktop surfaces. Scoped to this view on purpose: every other page keeps
 * its desktop layout down to 768px.
 *
 * Media-query based like those two, so a window resize re-picks live. Server
 * snapshot is `false` (the three-column layout), matching `useIsDesktop`'s
 * "desktop is the safe pre-hydration render".
 */
const NARROW_QUERY = '(max-width: 949px)'

export function useIsNarrowChatHome(): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(NARROW_QUERY)
      // Crossing 950px swaps the chat home's tree and remounts its editor:
      // keep that editor's unsaved draft for the new tree (#897, `useDraftState`).
      const handler = () => { beginLayoutSwap(); cb() }
      m.addEventListener('change', handler)
      return () => m.removeEventListener('change', handler)
    },
    () => window.matchMedia(NARROW_QUERY).matches,
    () => false,
  )
}
